import "./index.css";
import { Routes, Route } from "react-router-dom";
import Admin from "./Pages/Admin.jsx";
import Login from "./Pages/Login.jsx";
import Personal from "./Pages/Personal.jsx";
import Pop from "./Pages/Pop.jsx";
import Events from "./Router/Events.jsx";
import Home from "./Pages/Home.jsx";
import About from "./Pages/About.jsx"

import Contact from "./Pages/Contact.jsx"

import Forecast from "./Pages/SolutionPages/Forecast"
import Churn from "./Pages/SolutionPages/Churn"
import Cost from "./Pages/SolutionPages/Cost"
import Follow from "./Pages/SolutionPages/Follow"
import Fraud from "./Pages/SolutionPages/Fraud"
import Marketing from "./Pages/SolutionPages/Marketing"
import Predict from "./Pages/SolutionPages/Predict"
import Personalized from "./Pages/SolutionPages/Predict"

import Library from "./Pages/library.jsx"

function App() {
  return (
    <div>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/pop" element={<Pop />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/personal" element={<Personal />} />
        <Route path="*" element={<Home />} />
        <Route path="/events" element={<Events />} />
        <Route path="/about" element={<About />} />
        <Route path="/library" element={<Library />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/forecast" element={<Forecast />} />

        <Route path="/churn" element={<Churn />} />
        <Route path="/cost" element={<Cost />} />
        <Route path="/follow" element={<Follow />} />
        <Route path="*" element={<Fraud />} />
        <Route path="*" element={<Marketing />} />
        <Route path="/predict" element={<Predict />} />
        <Route path="*" element={<Personalized />} />
      </Routes>
    </div>
  );
}

export default App;
